import type { GlobConfig } from '/#/config'

import { warn } from '/@/utils/log'
import { getAppEnvConfig } from '/@/utils/env'

export const useGlobSetting = (): Readonly<GlobConfig> => {
  const {
    VITE_GLOB_APP_TITLE,
    VITE_GLOB_API_URL,
    VITE_GLOB_APP_SHORT_NAME,
    VITE_GLOB_API_URL_PREFIX,
    VITE_GLOB_UPLOAD_URL,
    VITE_GLOB_APP_ID,
    VITE_GLOB_REDIRECT_URL,
    VITE_GLOB_PASSPOART_URL,
    VITE_GLOB_IS_CHECK_ROUTER_AUTH,
    VITE_GLOB_WS_URL,
    VITE_GLOB_IS_USER_CONFIG_USE_CACHE,
    VITE_AUTH_APPLICATION_URL,
    VITE_UPGRADE_OVERVIEW_URL,
    VITE_UPGRADE_OVERVIEW_DETAIL_URL,
    VITE_VEHICLE_VERSION_DISTRIBUTION_URL,
    VITE_GLOB_LOGIN_TYPE_SCAN,
    VITE_GLOB_LOGIN_TYPE_ACCOUNT,
    VITE_GLOB_LOGIN_TYPE_SSO,
    VITE_GLOB_LOGIN_TYPE_FL,
    VITE_GLOB_SC_API,
  } = getAppEnvConfig()

  if (!/[a-zA-Z\_]*/.test(VITE_GLOB_APP_SHORT_NAME)) {
    warn(
      `VITE_GLOB_APP_SHORT_NAME Variables can only be characters/underscores, please modify in the environment variables and re-running.`,
    )
  }

  // Take global configuration
  const glob: Readonly<GlobConfig> = {
    title: VITE_GLOB_APP_TITLE,
    apiUrl: VITE_GLOB_API_URL,
    scApi: VITE_GLOB_SC_API,
    shortName: VITE_GLOB_APP_SHORT_NAME,
    urlPrefix: VITE_GLOB_API_URL_PREFIX,
    uploadUrl: VITE_GLOB_UPLOAD_URL,
    appId: VITE_GLOB_APP_ID,
    redirectUrl: VITE_GLOB_REDIRECT_URL,
    passportUrl: VITE_GLOB_PASSPOART_URL,
    isCheckRouterAuth: VITE_GLOB_IS_CHECK_ROUTER_AUTH,
    wSUrl: VITE_GLOB_WS_URL,
    userConfigUseCache: VITE_GLOB_IS_USER_CONFIG_USE_CACHE,
    upgradeOverviewUrl: VITE_UPGRADE_OVERVIEW_URL,
    authApplicationUrl: VITE_AUTH_APPLICATION_URL,
    upgradeOverviewDetailUrl: VITE_UPGRADE_OVERVIEW_DETAIL_URL,
    vehicleVersionDistributionUrl: VITE_VEHICLE_VERSION_DISTRIBUTION_URL,
    loginTypeScan: VITE_GLOB_LOGIN_TYPE_SCAN || 'false',
    loginTypeAccount: VITE_GLOB_LOGIN_TYPE_ACCOUNT || 'true',
    loginTypeSSO: VITE_GLOB_LOGIN_TYPE_SSO || 'false',
    loginTypeFL: VITE_GLOB_LOGIN_TYPE_FL || 'false',
  }
  return glob as Readonly<GlobConfig>
}
